import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconShoppingBag2"><Path fillRule="evenodd" clipRule="evenodd" d="M7.99884 6C7.99884 3.79086 9.7897 2 11.9988 2C14.208 2 15.9988 3.79086 15.9988 6V7H16.0233C17.3864 7 18.5438 7.99858 18.7436 9.34699L20.151 18.847C20.3971 20.5081 19.11 22 17.4307 22H6.56696C4.8877 22 3.60056 20.5081 3.84665 18.847L5.25406 9.34699C5.45382 7.99858 6.61123 7 7.97437 7H7.99884V6ZM9.49884 7H14.4988V6C14.4988 4.61929 13.3796 3.5 11.9988 3.5C10.6181 3.5 9.49884 4.61929 9.49884 6V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag2;
